export class LmsIcsFetchError extends Error {
    /**
     * @param {string} code machine-readable: feed_forbidden | feed_empty | feed_fetch_failed | feed_not_configured | invalid_feed_url | empty_feed_url
     * @param {string} message
     * @param {number} [httpStatus]
     */
    constructor(code, message, httpStatus = 0) {
        super(message);
        this.name = 'LmsIcsFetchError';
        this.code = code;
        this.httpStatus = httpStatus;
    }
}

/**
 * @param {unknown} error
 * @returns {{ code: string, message: string }}
 */
export function getLmsIcsErrorInfo(error) {
    if (error instanceof LmsIcsFetchError) {
        return { code: error.code, message: error.message };
    }
    if (error && typeof error === 'object' && error.name === 'LmsIcsFetchError' && 'code' in error) {
        const e = /** @type {{ code?: string, message?: string }} */ (error);
        return { code: e.code || 'unknown', message: e.message || 'Request failed' };
    }
    if (error instanceof Error) {
        return { code: 'unknown', message: error.message };
    }
    return { code: 'unknown', message: 'Something went wrong' };
}
